export default {
  methods: {
    mixinConvertSymbol (currentString, targetSymbol) {
      let text = currentString
      if (currentString && currentString.split('&amp;')) {
        text = currentString.split('&amp;').join(targetSymbol)
      }
      return text
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/getters/functions.js